/* Deliberate one-time additions. Never copies a coffee selling_plan. */
(() => {
  function enhance(root = document) {
    root.querySelectorAll('.union-addon-action[hidden]').forEach(button => {
      button.hidden = false;
      const fallback = button.parentElement.querySelector('.union-addon-fallback');
      if (fallback) fallback.hidden = true;
    });
  }
  enhance();
  new MutationObserver(() => enhance()).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-union-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const region = button.closest('.union-addons');
    const status = region.querySelector('.union-addon-status');
    const buttons = region.querySelectorAll('[data-union-add]');
    buttons.forEach(item => { item.disabled = true; });
    status.textContent = 'Adding your one-time item…';
    try {
      const response = await fetch(button.dataset.addUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.unionAdd, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) {
        status.textContent = result.description || result.message || 'This item could not be added. Please view the product for availability.';
        buttons.forEach(item => { item.disabled = false; });
        return;
      }
      status.textContent = 'Added. Opening your cart…';
      window.location.assign(button.dataset.cartUrl);
    } catch (error) {
      status.textContent = 'We could not confirm the update. Open your cart to check before adding again.';
      const link = document.createElement('a');
      link.href = button.dataset.cartUrl;
      link.className = 'union-text-link';
      link.textContent = 'View cart';
      status.append(' ', link);
      /* Keep disabled: a lost response can follow a successful add. */
    }
  });
})();
